//Position Panel - Playing Surface
export var Court = {
  name: "position-select",
  component: "NewPositionSelect",
  layout: "court-map",
  mode: "visible",
  showOn: [true],
  actionGroups: [
    {
      actions: [
        // Show Floating Panel
        { action: "nextState", value: "main-buttons", type: "primary" },
      ],
      conditions: [],
    },
  ],
};
